/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AnimalSpeciesInputDto { 
    animalFeatureTypes?: Array<AnimalSpeciesInputDto.AnimalFeatureTypesEnum>;
    comment?: string;
    english: string;
    german: string;
    icon?: string;
    isDeprecated?: boolean;
    latin?: string;
    oldDenotations?: string;
    tag?: string;
}
export namespace AnimalSpeciesInputDto {
    export const AnimalFeatureTypesEnum = {
        ExtraWideOvalBeltShape: 'EXTRA_WIDE_OVAL_BELT_SHAPE',
        MandatoryProtectiveBelt: 'MANDATORY_PROTECTIVE_BELT'
    } as const;
    export type AnimalFeatureTypesEnum = typeof AnimalFeatureTypesEnum[keyof typeof AnimalFeatureTypesEnum];
}


